import pt from "../../locales/pt.json";

export const textoInfo1 = pt.infoTextos.textoInfo1;
export const textoInfo2 = pt.infoTextos.textoInfo2;
export const textoInfo3 = pt.infoTextos.textoInfo3;
export const textoInfo4 = pt.infoTextos.textoInfo4;
export const textoInfo5 = pt.infoTextos.textoInfo5;
export const textoInfo6 = pt.infoTextos.textoInfo6;